import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const AttendanceLogsPageHeader = () => {
  const { t } = useTranslation()

  return <PageHeader ghost={false} title={t('components.pages.attendanceLogs.list.pageHeader.title')} />
}

AttendanceLogsPageHeader.displayName = 'AttendanceLogsPageHeader'
export default AttendanceLogsPageHeader
